import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="border-b border-background-50/10 py-14 text-center">
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            {t("cta.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-background-200 md:text-base">
            {t("cta.desc")}
          </p>
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full rounded-full bg-accent-500 px-7 py-3 text-center text-base font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto whitespace-nowrap"
            >
              {t("cta.primary")}
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full rounded-full border border-background-50/40 px-7 py-3 text-center text-base font-semibold text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto whitespace-nowrap"
            >
              {t("cta.secondary")}
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 py-12 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line text-base"></i>
              </span>
              <span className="font-heading text-base font-bold text-background-50">
                {t("nav.brand")}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">{t("footer.about")}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              {t("footer.quickLinks")}
            </h4>
            <ul className="mt-4 flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t("footer.home")}
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t("footer.categories")}
                </Link>
              </li>
              <li>
                <Link to="/#guides" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t("footer.guides")}
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t("footer.faq")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              {t("footer.resources")}
            </h4>
            <ul className="mt-4 flex flex-col gap-2">
              <li>
                <Link
                  to="/#guides"
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  {t("nav.guides")}
                </Link>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  {t("main.usfansSpreadsheet")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-50/10 py-6 sm:flex-row">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} {t("nav.brand")}. {t("footer.rights")}
          </p>
          <p className="max-w-xl text-center text-xs text-background-300 sm:text-right">
            {t("footer.disclaimer")}
          </p>
        </div>
      </div>
    </footer>
  );
}